module.exports = __webpack_public_path__ + "img/jl.9b4b4a5c.jpg";